import { render, staticRenderFns } from "./activitySettingList.vue?vue&type=template&id=97277b62&scoped=true&"
import script from "./activitySettingList.vue?vue&type=script&lang=js&"
export * from "./activitySettingList.vue?vue&type=script&lang=js&"
import style0 from "./activitySettingList.vue?vue&type=style&index=0&id=97277b62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97277b62",
  null
  
)

export default component.exports